import {Component, Input, OnInit} from '@angular/core';
import {User} from '../../model/user';
import {Version} from '../../model/version';

@Component({
    selector: 'mir-sdis-activity',
    templateUrl: './sdis-activity.component.html',
    styleUrls: ['./sdis-activity.component.css'],
    standalone: false
})
export class SdisActivityComponent implements OnInit {

  @Input()
  user: User;

  @Input()
  version: Version;

  alarmsAvailable = false;
  googleCalendarAvailable = false;

  ngOnInit(): void {
    this.alarmsAvailable = this.version?.isAuthorized('MSGR') && this.user.isAuthorized('OP_MSGR');
    this.googleCalendarAvailable = this.version?.isAuthorized('GOOGLECALENDAR');
  }

  get hasAnyContent(): boolean {
    return this.alarmsAvailable || this.googleCalendarAvailable;
  }
}
